module.exports = __webpack_public_path__ + "static/media/background.38f6f329.png";